<template>
  <div>
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header bordered mb0">
            <div class="row">
              <div class="col-md-8">
                <h1>
                  <i class="fa fa-gift" aria-hidden="true"></i>
                  {{ giftCard.title }}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="content" class="item-single">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <div class="row justify-content-md-center has-sidebar mb-4">
              <div class="col-md-7 col-lg-8">
                <div>
                  <div v-if="giftCard.image_url" class="item-gallery">
                    <img :src="giftCard.image_url" class="img-fluid">
                  </div>
                  <div v-else class="text-center">
                    <i class="fa fa-picture-o without-image" aria-hidden="true"></i>
                  </div>

                  <div>
                    <div class="item-description">
                      <h3 class="headline">
                        Gift Card Description
                      </h3>
                      <div v-html="markedText(giftCard.description)">
                      </div>
                    </div>

                    <h3 class="headline">Organizer Details</h3>
                    <strong> {{ giftCard.organizer_name }} </strong>
                    <p> {{ giftCard.organizer_description }} </p>

                    <template v-if="giftCard.organizer_website">
                      <a :href="giftCard.organizer_website" target="_blank">
                        {{ giftCard.organizer_website }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="giftCard.organizer_contact_phone_number">
                      <a :href="`tel:+1${extracNumbers(giftCard.organizer_contact_phone_number)}`"
                        rel="nofollow">
                        {{ giftCard.organizer_contact_phone_number }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="giftCard.organizer_facebook_id">
                      <a :href="socialMediaLinks(giftCard.organizer_facebook_id, 'facebook')" target="_blank">
                        <i class="fa fa-facebook-official" aria-hidden="true"></i>
                        {{ giftCard.organizer_facebook_id }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="giftCard.organizer_twitter_id">
                      <a :href="socialMediaLinks(giftCard.organizer_twitter_id, 'twitter')" target="_blank">
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                        {{ giftCard.organizer_twitter_id }}
                      </a>
                      <br/>
                    </template>

                    <template v-if="giftCard.organizer_instagram_id">
                      <a :href="socialMediaLinks(giftCard.organizer_instagram_id, 'instagram')" target="_blank">
                        <i class="fa fa-instagram" aria-hidden="true"></i>
                        {{ giftCard.organizer_instagram_id }}
                      </a>
                      <br/>
                    </template>

                    <b-button v-b-modal.formContactModal
                      class="btn btn-lg btn-primary btn-block mt-5">
                      Contact Us
                    </b-button>

                    <ContactForm
                      :giftCard="giftCard">
                    </ContactForm>
                  </div>
                </div>
              </div>

              <div class="col-md-5 col-lg-4">
                <div id="sidebar" class="sidebar-right">
                  <div class="sidebar_inner">
                    <div id="feature-list" role="tablist">
                      <div class="card">
                        <h5 class="subheadline mt-0  mb-0">
                          <i class="fa fa-gift" aria-hidden="true"></i> Buy
                        </h5>

                        <div v-if="giftCard.limited_time_bonus_enabled && !giftCard.limited_time_bonus_out_of_date"
                          class="card-body">
                          <h5>
                            Get a <strong>{{ giftCard.bonus_percentage }}% bonus!</strong>
                            <br />
                            <small> (until {{ giftCard.formatted_limited_time_bonus_date }}) </small>
                          </h5>
                        </div>

                        <b-button v-b-modal.giftCardSelectionModal class="btn btn-lg btn-primary btn-block">
                          Buy Gift Card
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <GiftCardSelectionModal
      :giftCard="giftCard"
    />

    <script v-html="giftCardStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import ContactForm from '../common/ContactForm'
import GiftCardSelectionModal from './GiftCardSelectionModal'
import GiftCardService from '../../services/GiftCardService'
import StructuredData from '../common/StructuredData'

export default {
  name: 'GiftCardShow',
  mixins: [StructuredData],
  components: {
    ContactForm,
    GiftCardSelectionModal
  },
  data: function () {
    return {
      giftCard: this.$route.params.gift_card || {
        needLoading: true,
        description: '',
        purchase_message: ''
      },
      giftCardStructuredData: {},
      giftCardId: this.$route.params.id
    }
  },
  created () {
    this.loadGiftCardStructuredData(this.giftCardId)
    if (this.giftCard.needLoading) {
      this.loadGiftCard()
    }
  },
  mounted () {
    if (this.showTicketSelectionModal) {
      this.$bvModal.show('giftCardSelectionModal')
    }
  },
  methods: {
    loadGiftCard () {
      var self = this
      var loader = this.$loading.show()

      GiftCardService.getGiftCard(this.giftCardId).then(function (response) {
        self.giftCard = response.data
        self.giftCard.needLoading = false

        if (!self.giftCard.enabled) {
          self.$router.push('/gift-cards')
        }
      }).finally(function () {
        loader.hide()
      })
    }
  }
}
</script>
